import initMultiselect from './subscriptionMultiSelect';
import initRadioSelect from './subscriptionRadioSelect';

export default function (selectContainer: HTMLElement): void {
    const subscriptionValue = selectContainer.querySelector('.js-subscriptionFrequencyValue') as HTMLInputElement;

    initMultiselect(selectContainer, subscriptionValue);

    initRadioSelect(selectContainer, subscriptionValue);
}
